module.exports = __webpack_public_path__ + "img/share-nodes.dbc55548.svg";